import { generateReserveReport } from './apiGenerateReserveReport';
import { globalErrorResponse } from '../../../../shared/notification/actions';
import { useMutation } from '@tanstack/react-query';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../../../shared/utils/togglz';
import * as consts from '../../../../store/constants';
import { useNavigate } from 'react-router-dom';

export const useGenerateReserveReportMutation = () => {
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);
    const navigate = useNavigate();

    return useMutation(generateReserveReport, {
        onSuccess: data => {
            if (data?.reserveListId) {
                navigate(
                    isCollectionNavigationV2Enabled
                        ? `/collectionmgmt/reserves/${data.reserveListId}`
                        : `${consts.PATH_RESERVE}/${data.reserveListId}`
                );
            }
        },
        onError: error => globalErrorResponse(error as unknown as string)
    });
};
